export default __webpack_public_path__ + "static/media/pending.26eb2c7d.svg";